import { useState } from "react";

interface ProgramImageGalleryProps {
    images: string[];
    title: string;
    color: string;
}

export default function ProgramImageGallery({ images, title, color }: ProgramImageGalleryProps) {
    const [activeImageIndex, setActiveImageIndex] = useState(0);

    if (!images.length) return null;

    const activeImage = images[activeImageIndex];

    const handlePrev = () => {
        setActiveImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setActiveImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="max-w-4xl">
        <div className="overflow-hidden rounded-2xl border bg-black shadow">
            <div className="relative w-full pb-[56.25%] bg-black">
            <img
                src={activeImage}
                alt={`${title} gallery image ${activeImageIndex + 1}`}
                className="absolute inset-0 h-full w-full object-contain"
            />

            {images.length > 1 && (
                <>
                <button
                    type="button"
                    onClick={handlePrev}
                    aria-label="Previous image"
                    className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/85 px-3 py-2 text-sm font-bold shadow"
                    style={{ color }}
                >
                    ←
                </button>

                <button
                    type="button"
                    onClick={handleNext}
                    aria-label="Next image"
                    className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/85 px-3 py-2 text-sm font-bold shadow"
                    style={{ color }}
                >
                    →
                </button>
                </>
            )}
            </div>
        </div>

        {images.length > 1 && (
            <div className="mt-4 flex flex-wrap gap-3">
            {images.map((image, index) => {
                const isActive = index === activeImageIndex;

                return (
                <button
                    key={`${image}-${index}`}
                    type="button"
                    onClick={() => setActiveImageIndex(index)}
                    aria-label={`Show image ${index + 1}`}
                    className={`overflow-hidden rounded-xl border-2 transition ${
                    isActive ? "opacity-100" : "opacity-70 hover:opacity-100"
                    }`}
                    style={{ borderColor: isActive ? color : "#e5e7eb" }}
                >
                    <img
                    src={image}
                    alt=""
                    className="h-16 w-24 object-cover"
                    />
                </button>
                );
            })}
            </div>
        )}

        <p className="mt-3 text-sm font-medium text-gray-600">
            Image {activeImageIndex + 1} of {images.length}
        </p>
        </div>
    );
}